export default __webpack_public_path__ + "static/media/000_intro_part1.e52dee68.mp4";